<template>
    <div class="market-accordion-container">
        <accordion :items="block.steps" :class="block.accordion_color" selector-background="bg-white-with-lines">
            <template v-slot:accordion-selector-title="{item}">
                <span class="title" v-html="item.title"></span>
            </template>
            <template v-slot:accordion-item-header-title="{item, itemIndex}">
                <div class="title"><span class="number large-number text-outline" v-html="getFormattedNumber(itemIndex)"></span> <span class="text" v-html="item.title"></span></div>
                <div class="expanded-title">
                    Step <span class="number" v-html="itemIndex+1"></span> <span class="text" v-html="item.title"></span>
                </div>
            </template>
            <template v-slot:accordion-item-content="{item, itemIndex}">
                
                <div class="container">
                    <div class="process">
                        <div class="process-step">
                            <div class="header-image">
                                <div v-if="item.add_background_overlay" class="overlay" :style="{opacity: item.background_overlay_opacity}"></div>
                                <img :src="item.header_image.url">
                            </div>
                            <div class="content bg-dark-blue">
                                <div class="flex">
                                    <div class="col">
                                        <div class="roboto-mono number text-outline" v-html="getFormattedNumber(itemIndex)"></div>
                                    </div>
                                    <div class="col">
                                        <div class="top-title" v-html="item.content.top_title" v-if="item.content.top_title"></div>
                                        <h2 class="title" v-html="item.content.title" v-if="item.content.title"></h2>
                                        <div class="copy" v-html="item.content.copy" v-if="item.content.copy"></div>
                                        <div class="button-container" v-if="item.content.button">
                                            <a class="hover-button orange" :href="item.content.button.url" :target="item.content.button.target" v-html="item.content.button.title"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="process-highlights">
                            <div class="highlight" v-for="(highlight, index) in item.highlights" :key="index">
                                <div class="top-title" v-html="highlight.top_title" v-if="item.content.top_title"></div>
                                <h2 class="title" v-html="highlight.title" v-if="item.content.title"></h2>
                                <div class="copy" v-html="highlight.copy" v-if="item.content.copy"></div>
                                <div class="button-container" v-if="highlight.button">
                                    <a class="hover-button orange" :href="highlight.button.url" :target="highlight.button.target" v-html="highlight.button.title"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </accordion>
    </div>
</template>

<script>
export default {
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    mounted() {
    },
    methods: {
        getFormattedNumber(index) {
            index++;
            if (index < 10) {
                index = "0"+index;
            }
            return index;
        },
    }
}
</script>